/************************************************************
 * app-services.ts
 * Contiene los servicios para Sponsor, SEO, Banner, Program y Blog
 ************************************************************/

import axios from "axios";
import { CRUDService } from "../crud-service.service";
import { Sponsor, SEO, Banner, Program, Blog, Category, HomePage } from "../../models/db";
import { Configuration } from "../../models/db/configuration";
import { PageType, WebPage } from "../../models/db/web-page";
// Ajustar las rutas de import segun tu proyecto:


// Ajusta la URL a la que apuntan tus servicios
const apiUrl = process.env.REACT_APP_API_URL_MS_AUTH;

//----------------------------------------------------------------------------------
// SponsorService
//----------------------------------------------------------------------------------
export class SponsorService extends CRUDService<Sponsor> {

    private nameRoute = "sponsor";
    constructor() {
        super(apiUrl, "sponsor");
    }

    // Si hubiera métodos extra o rutas distintas al CRUD, agrégalos aquí
    // Ejemplo:
    // deleteDefinitive(idList: number[], extraParam: string) {
    //     return axios.post(`${apiUrl}/api/sponsor/delete-definitive`, { idList, extraParam }, { withCredentials: true });
    // }

    // /sponsor/manage-image
    manageImage(imageAddList: any[],
        imageUpdateList: any[],
        deleteImageList: any[]) {
        return axios.post(`${apiUrl}/api/${this.nameRoute}/manage-image`, {
            imageAddList,
            imageUpdateList,
            deleteImageList
        }, { withCredentials: true });
    }


}

//----------------------------------------------------------------------------------
// SEOService
//----------------------------------------------------------------------------------
export class SEOService extends CRUDService<SEO> {
    private nameRoute = "seo";
    constructor() {
        super(apiUrl, "seo");
    }

    // Métodos extra...
    checkSpecificParam(value: { id: string, value: string, param: string }) {
        return axios.post(`${apiUrl}/api/${this.nameRoute}-check`, { value }, { withCredentials: true });
    }
}

//----------------------------------------------------------------------------------
// BannerService
//----------------------------------------------------------------------------------
export class BannerService extends CRUDService<Banner> {
    constructor() {
        super(apiUrl, "banner");
    }

    // Métodos extra...
}

//----------------------------------------------------------------------------------
// ProgramService
//----------------------------------------------------------------------------------
export class ProgramService extends CRUDService<Program> {
    private nameRoute = "program";
    constructor() {
        super(apiUrl, "program");
    }

}

//----------------------------------------------------------------------------------
// ProgramService
//----------------------------------------------------------------------------------

export class HomeService extends CRUDService<HomePage> {
    private nameRoute = "homepage";
    constructor() {
        super(apiUrl, "homepage");
    }

}

//----------------------------------------------------------------------------------
// BlogService
//----------------------------------------------------------------------------------
export class BlogService extends CRUDService<Blog> {
    constructor() {
        super(apiUrl, "blog");
    }

    // Métodos extra...
}


export class ConfigurationService extends CRUDService<Configuration> {
    constructor() {
        super(apiUrl, "configuration");
    }
}

export class CategoryService extends CRUDService<Category> {
    nameRoute = "category";
    constructor() {
        super(apiUrl, "category");
    }

    autocomplete() {
        return axios.get(`${apiUrl}/api/${this.nameRoute}/autocomplete`, { withCredentials: true });
    }
}


//----------------------------------------------------------------------------------
// BlogService
//----------------------------------------------------------------------------------
export class WebPageService extends CRUDService<WebPage> {
    constructor() {
        super(apiUrl, "web-page");
    }

    getByType(type: PageType) {
        // /web-page-:type
        return axios.get(`${apiUrl}/api/web-page/type-${type}`, { withCredentials: true });
    }

    // Métodos extra...
}